export const hasCurrentCategory = (categories) => {
    const currCat = getCurrentCategory(categories);
    return !!currCat;
};

function getCurrentCategory(categories) {
    if (categories && categories.length) {
        for (let i = 0, n = categories.length; i < n; i++) {
            const cat = categories[i];
            if (cat.isCurrentCategory) {
                return cat;
            }
            const currentCat = getCurrentCategory(cat.categories);
            if (currentCat) {
                return currentCat;
            }
        }
    }
}
